// src/pages/orders/ContinentalOrderHistory.jsx
import React from 'react';
import OrderHistory from '../Waiters_OrderHistory';

const ContinentalOrderHistory = () => {
  return <OrderHistory locationKey="continental" />;
};

export default ContinentalOrderHistory;